import { render, staticRenderFns } from "./SliderWithNumberBase.vue?vue&type=template&id=f1dad8ba"
import script from "./SliderWithNumberBase.vue?vue&type=script&lang=js"
export * from "./SliderWithNumberBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports